import {
  ApiDateFormat,
  BaseModel,
} from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  BankPaymentChargeBearer,
  BankPaymentInstantFlow,
  BankPaymentProduct,
  BankPaymentState,
  IBankPayment,
  IBankPaymentStatusUpdate,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';
import { InvoiceCustomer } from './invoice-customer.model';
import { Payment } from './payment.model';

export class BankPayment
  extends BaseModel<BankPayment, 'BankPayment'>
  implements IBankPayment
{
  static override readonly modelName: AbilitySubjectType = 'BankPayment';

  product!: BankPaymentProduct;
  state!: BankPaymentState;
  bankAccountIban!: string;
  @Type(() => Number)
  amount!: number;
  currency!: string;
  creditorName!: string;
  creditorIban!: string;
  creditorBic?: string | null;
  chargeBearer?: BankPaymentChargeBearer | null;
  instantPaymentFlow?: BankPaymentInstantFlow | null;
  variableSymbol?: string | null;
  specificSymbol?: string | null;
  constantSymbol?: string | null;
  remittanceInformation?: string | null;
  @Type(() => Date)
  @ApiDateFormat()
  requestedExecutionDate?: Date | null;
  instructionId!: string;
  endToEndId!: string;
  customerId?: string | null;
  @Type(() => InvoiceCustomer)
  customer?: InvoiceCustomer;
  returnedPaymentId?: string | null;
  @Type(() => Payment)
  returnedPayment?: Payment;
  paymentId?: string | null;
  @Type(() => Payment)
  payment?: Payment;
  tatraPaymentId?: string | null;
  tatraAuthorizationId?: string | null;
  transactionStatus?: string | null;
  statusUpdates?: IBankPaymentStatusUpdate[] | null;
  scaRedirectUrl?: string | null;

  get lastStatusUpdate() {
    return this.statusUpdates?.at(-1) ?? null;
  }
}
